import { useState, useEffect } from "react";
import { SEND_EVENTS_TO_PENDO, PENDO_API_KEY } from "env-vars";
import { pendoSnippet } from "./pendo-snippet";
import { useLocationContext } from "context/location";

export function Pendo() {
  const [pendoInitialised, setPendoInitialised] = useState<boolean | null>(
    null
  );
  const locationData = useLocationContext();
  const location = locationData?.location;

  useEffect(() => {
    if (locationData?.isLoading) {
      setPendoInitialised(false);
      return;
    }

    if (pendoInitialised) return;

    if (!PENDO_API_KEY || !SEND_EVENTS_TO_PENDO) {
      setPendoInitialised(false);

      return;
    }

    pendoSnippet({ apiKey: PENDO_API_KEY, location });

    setPendoInitialised(true);
  }, [pendoInitialised, locationData, location]);

  return <div style={{ display: "none" }} data-pendo-init={pendoInitialised} />;
}
